<template>
  <div class="gs-search">
    <div class="selector-tabs" v-if="isVisible">
      <GroupSelectorTabs @activate-tab="onSwitchTab"/>
      <div class="search-holder" container>
        <GroupSelectorSearchForm/>
        <GroupSelectorSearchResults @item-select="onItemSelect"/>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { useStore } from '@vue3shims';
import { camelToTitle } from '@utils';
import GroupSelectorTabs from '@molecules/v2/GroupSelector/GroupSelectorTabs.vue';
import GroupSelectorSearchForm from '@molecules/v2/GroupSelector/GroupSelectorSearchForm.vue';
import GroupSelectorSearchResults from '@molecules/v2/GroupSelector/GroupSelectorSearchResults.vue';


export default {
  setup(_, { emit }) {
    const store = useStore();
    const tabs = computed(() => store.getters['groupSelector/tabs']);
    const currentTab = computed(() => store.getters['groupSelector/currentTab'] || null);
    const searching = ref(false);

    const onItemSelect = (item) => {
      emit('item-select', item);
    }

    const onSwitchTab = (tab) => {
      // emit this
      emit('activate-tab', tab);
    }

    return {
      camelToTitle,
      currentTab,
      onItemSelect,
      onSwitchTab,
      searching,
      tabs,
    }
  },
  emits: ['activate-tab'],
  props: {
    isVisible: {
      type: Boolean,
      default: () => false,
      required: true,
    }
  },
  components: {
    GroupSelectorSearchForm,
    GroupSelectorSearchResults,
    GroupSelectorTabs,
  }
}
</script>

<style lang="scss" scoped>
.gs-search {
  background-color: $color-light-gray-alt;
  .selector-tabs {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100vw;
    z-index: 200;
    position: absolute;
    background: $color-light-gray-alt;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.15);

    .search-holder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      padding-top: 1.1rem;
      padding-bottom: 1.1rem;
    }
  }
}
</style>
